import { IMarketYoyGrowthExpectation } from '../model/types'

type TMarketYoyGrowthExpectationIdentity = Pick<
  IMarketYoyGrowthExpectation,
  'fYear' | 'rtm' | 'market' | 'offering' | 'productCategory'
>

/**
 * Identity key of an expectation record: every field except the editable
 * values and the derived `state`. Used to address records in the edits map.
 * Accepts a bare identity (not a full record) so synthesized/phantom
 * combinations can be keyed the same way as fetched records.
 */
export const getMarketYoyGrowthExpectationKey = (
  record: TMarketYoyGrowthExpectationIdentity
): string =>
  [record.fYear, record.rtm, record.market, record.offering, record.productCategory].join('|')
